import sliceByNumber from './sliceByNumber';

type CanvasWriteProps = {
    canvas: HTMLCanvasElement
    image: HTMLImageElement
    font: string
    fontSize: number
    fontColor: string
}

export default class WriteTextOnCanvas {
  private props: CanvasWriteProps;
  private context: CanvasRenderingContext2D;
  private vertical = true;
  private maxCharsPerLine: number;
  private value: string;

  constructor(props: CanvasWriteProps) {
    this.props = props;
    this.context = this.props.canvas.getContext('2d');
    this.initialize();
  }

  initialize() {
    this.props.canvas.width = this.props.image.width;
    this.props.canvas.height = this.props.image.height;
    this.maxCharsPerLine = this.vertical
      ? Math.ceil((this.props.image.height - this.props.fontSize * 2) / this.props.fontSize)
      : Math.ceil((this.props.image.width - this.props.fontSize) / this.props.fontSize);
    this.context.font = this.props.fontSize + 'px ' + this.props.font;
    this.context.fillStyle = this.props.fontColor;
    this.context.drawImage(this.props.image, 0, 0);
    this.vertical
      ? this.context.translate(this.props.fontSize * (this.maxCharsPerLine - 1), this.props.fontSize * 1.5)
      : this.context.translate(this.props.fontSize * 0.5, 0);
  }

  changeImage(image: HTMLImageElement) {
    this.props.image = image;
    this.write(this.value);
  }

  changeFontSize(fontSize: number) {
    this.props.fontSize = fontSize;
    this.write(this.value);
  }

  changeMode(mode: string) {
    this.vertical = mode === 'vertical';
    this.write(this.value);
  }

  write(value: string) {
    this.value = value;
    this.initialize();

    const ambitions = value
      .split('\n')
      .map(value => [...value])
      .map(ambition => {
        if (ambition.length > this.maxCharsPerLine) {
          return sliceByNumber(ambition, this.maxCharsPerLine);
        }
        return [ambition];
      })
      .flat(1);

    ambitions.forEach(rows => {
      this.vertical
        ? this.context.translate(-this.props.fontSize, 0)
        : this.context.translate(0, this.props.fontSize);

      this.context.save();

      rows.forEach((value: string) => {
        if (this.vertical) {
          if (value.search(new RegExp(/[ー〜\-~「」[\]（）()＜＞<>｛｝{}；：;:｜|＝=/／_＿]/, 'g')) !== -1) {
            this.context.rotate((90 * Math.PI / 180));
            this.context.translate(-this.props.fontSize, 0);
            this.context.fillText(value, 0, 0);
            this.context.rotate(-1 * (90 * Math.PI / 180));
            this.context.translate(0, this.props.fontSize);
          } else if (value.search(new RegExp(/[。、.,]/, 'g')) !== -1) {
            this.context.fillText(value, this.props.fontSize * 0.7, -this.props.fontSize * 0.7);
          } else {
            this.context.fillText(value, 0, 0);
          }
        } else {
          this.context.fillText(value, 0, 0);
        }

        this.vertical
          ? this.context.translate(0, this.props.fontSize)
          : this.context.translate(this.props.fontSize, 0);
      });

      this.context.restore();
    });
  }

  toDataURL(): string {
    return this.props.canvas.toDataURL('image/png');
  }

  toBlob(callback: BlobCallback): void {
    return this.props.canvas.toBlob(callback);
  }

  text(): string {
    return this.value;
  }
}
